import { useContext } from 'react';
import { WorkspaceFilePreviewLoadingContext } from '../Context';

export const useFilePreviewLoading = () => {
  const loading = useContext(WorkspaceFilePreviewLoadingContext);

  return loading;
};

export default useFilePreviewLoading;